var VIEW_MODE = {
    SITE: 'SITE',
    EDIT: 'EDIT',
    PREVIEW: 'PREVIEW',
    SEO: 'SEO',
};
export default VIEW_MODE;
//# sourceMappingURL=viewMode.js.map